import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

interface Payload {
  geofence: Omit<uui.domain.client.gps.wwgps.Geofence, 'id'>
  bounds: uui.domain.LatLngBounds
}

/**
 * Create a single geofence
 *
 * @private
 */
export const createGeofence = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/geofence/create', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/geofence/create', {
      category: 'rpc',
      type: 'rpc/geofence/create',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createGeofence}`,
      { tags: ['rpc', 'geofence'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create geofence failed`,
      error,
    })
  }
})
